import { motion } from "framer-motion";
import { Ticket, Handshake } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { EVENT_2026_PHOTOS, VARNA_2027, TICKET_2027 } from "@/lib/platform";
import { goToTicketCheckout } from "./NationalNav";

export default function FinalCTA() {
  const navigate = useNavigate();

  return (
    <section data-testid="final-cta" className="relative min-h-[85svh] bg-[#0B1F3D] text-[#F5EBD9] flex items-center overflow-hidden">
      {/* Dramatic event photo background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${EVENT_2026_PHOTOS[1].src})` }}
      />
      <div className="absolute inset-0 bg-[#0B1F3D]/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1F3D] via-transparent to-[#07152B]" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 text-center w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1 }}
        >
          <h2 className="font-display uppercase text-4xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight">
            Не гледай играта отстрани.<br />
            <span className="text-[#F5892E]">Бъди част от нея.</span>
          </h2>

          <div className="mt-8 font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-[#F5EBD9]/80">
            Варна | {VARNA_2027.dateShort}
          </div>
          <div className="mt-3 font-display uppercase text-2xl sm:text-3xl">
            Early Bird — <span className="text-[#F5892E]">{TICKET_2027.price} €</span>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={goToTicketCheckout}
              data-testid="final-cta-ticket"
              className="inline-flex items-center gap-3 px-10 py-5 rounded-full bg-[#F5892E] text-[#0B1F3D] font-bold text-base uppercase tracking-widest hover:bg-[#F5EBD9] transition-colors shadow-[0_15px_50px_-10px_rgba(245,137,46,0.6)]"
            >
              <Ticket className="w-5 h-5" strokeWidth={2.4} />
              Вземи своя билет
            </button>
            <button
              onClick={() => { navigate("/partners"); window.scrollTo({ top: 0 }); }}
              data-testid="final-cta-partner"
              className="inline-flex items-center gap-3 px-10 py-5 rounded-full border border-[#F5EBD9]/40 text-[#F5EBD9] font-medium text-base uppercase tracking-widest hover:bg-[#F5EBD9] hover:text-[#0B1F3D] transition-all"
            >
              <Handshake className="w-5 h-5" strokeWidth={2.2} />
              Стани партньор
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
